/* eslint-disable max-len */
import React from 'react';

const undoIcon = props => (
  <svg width="19px" height="19px" viewBox="0 0 19 19" {...props}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(3.000000, 3.000000)" fill="currentColor" fillRule="nonzero">
        <path
          d="M5.84025878,0.134851469 L6.35974122,0.604040132 L4.94038416,2.1736918 C5.31801204,2.09184132 5.70619176,2.05 6.1,2.05 C9.10995189,2.05 11.55,4.49004811 11.55,7.5 C11.55,10.5099519 9.10995189,12.95 6.1,12.95 C3.16346157,12.95 0.769365764,10.6275271 0.654327502,7.71919617 L0.65,7.5 L1.35,7.5 C1.35,10.1233526 3.47664744,12.25 6.1,12.25 C8.72335256,12.25 10.85,10.1233526 10.85,7.5 C10.85,4.87664744 8.72335256,2.75 6.1,2.75 C5.62381821,2.75 5.15770309,2.81999077 4.71257593,2.95571988 L6.36376971,4.84941226 L5.83623029,5.30952328 L3.54217296,2.67927615 L5.84025878,0.134851469 Z"
          id="Undo"
        />
      </g>
    </g>
  </svg>
);

export default undoIcon;
